import { marked } from 'marked'

// Get domain from translation
export function useDomain(lowercase = true) {
  const { t } = useI18n()
  return lowercase
    ? t('shared.domain').toLowerCase()
    : t('shared.domain')
}

// Get env attribute
export function useEnv(attribute = null) {
  const runtimeConfigPublic = useRuntimeConfig().public
  if (attribute) return runtimeConfigPublic[attribute]
  return { ...runtimeConfigPublic }
}

// Create promise delay
export function useDelay(delay) {
  return new Promise(resolve => setTimeout(resolve, delay))
}

// Get full path for request
export function useFullPath(path = '') {
  const url = useRequestURL()
  return `${url.protocol}//${url.host}${path}`
}

// Pretty join an array based on delimiter and last delimiter
export function usePrettyJoin(array, delimiter = ',', lastDelimiter = '&') {
  return [
    ...array.slice(0, -2),
    array.slice(-2).join(` ${lastDelimiter} `)
  ].join(`${delimiter} `)
}

// Capitalize the first letter in a string 
export function useUcFirst(str = '') {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

// Use marked lib for markdown
export function useMarked(str) {
  return marked.parse(str)
}

// Parse a timestamp into a dayjs object using the environment timezone
export function useLocalizedDayjs(timestamp) {
  const dayjs = useDayjs()

  const parsed = typeof timestamp === 'number'
    ? dayjs.unix(timestamp)
    : dayjs(timestamp)

  const timezone = import.meta.server
    ? useEnv('timezone')
    : dayjs.tz.guess()

  return parsed.tz(timezone)
}

// Add date wrapper for convenience
export function useDate(timestamp) {
  return useLocalizedDayjs(timestamp)
}

// Filter an array of objects based on a specific attribute to remove duplicates
export function useUniqueBy(array, attribute) {
  if (!array?.length || !array[0] || !array[0][attribute]) return []
  const seenValues = new Set()
  
  return array.filter(obj => {
    const value = obj[attribute]
    if (!seenValues.has(value)) {
      seenValues.add(value)
      return true
    }
    return false
  })
}

// Use rgba colors from hex value
export function useHexToRgba(hex, alpha = 1) {
  const r = parseInt(hex?.slice(1, 3), 16)
  const g = parseInt(hex?.slice(3, 5), 16)
  const b = parseInt(hex?.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}